export default __webpack_public_path__ + "static/media/herrera.c8389c01.jpg";